import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';

import * as jQuery from 'jquery';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent extends ComponentBase implements OnInit {

  content: boolean;
  loaded: boolean = false;
  loadedContent: boolean = false;
  loadedContentItem: boolean = false;
  uniqueId: string;

  constructor() { 
    super() 
    this.uniqueId = Math.random().toString(36).substring(2) + Date.now().toString(36);
  }

  ngOnInit() {
  }

  ngLoaded() {
    if (!this.loaded) {
      let index = 0;
      this.attribute.attributes.forEach(element => {

        $('#m_accordion_7_' + this.uniqueId + index + '_head').attr('href', '#m_accordion_7_' + this.uniqueId + index + '_body');
        $('#m_accordion_7_' + this.uniqueId + index + '_body').attr('aria-labelledby', '#m_accordion_7_' + this.uniqueId + index + '_head');

        $('#m_accordion_8_' + this.uniqueId + index + '_head').attr('href', '#m_accordion_8_' + this.uniqueId + index + '_body');
        $('#m_accordion_8_' + this.uniqueId + index + '_body').attr('aria-labelledby', '#m_accordion_8_' + this.uniqueId + index + '_head');
        
        index = index + 1;

      });
    }
    else
      this.loaded = true;
  }

  hasContent(value: AttributeModel[]) {
  }

  hasItemContent(value: AttributeModel): boolean {
    let isHidden = false;
    return isHidden
  }
}
